@if (hasViewOrEditPermission) {
    <div class="card panel-flat-color secondary-panel">
        <div (click)="expandOrCollapse()" [ngClass]="{'pointer': !isEdit}" class="panel-flat-header">
            <panel-chevron [showBody]="showBody"></panel-chevron>
            <h3>Contacts</h3>
            <div (click)="$event.stopPropagation()" class="float-end header-button-container">
                @if (!isEdit && showBody && hasEditPermission && isCompany) {
                    <label style="margin-right: 15px;">
                        <input (change)="showAllContacts()" [ngModel]="showAll" type="checkbox"> Show All
                    </label>
                }
                @if (!isEdit && !editLock && showBody && (hasEditPermission || isConsultantUser)) {
                    <button (click)="edit()"
                            class="ace-btn btn-text has-icon btn-primary">
                        <i class="fa fa-pencil"></i>
                    </button>
                }
                @if (isEdit && showBody) {
                    <button (click)="cancel()" class="ace-btn btn-text has-icon btn-primary btn-danger">
                        <i class="fa fa-close"></i>
                    </button>
                }
            </div>
        </div>
        @if (showBody) {
            <div class="card-body ws-flex-container-vertical" style="height: 300px">
                @if (isLoading) {
                    <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
                }
                @if (isEdit) {
                    <contacts-panel-body-actions [contacts]="contacts"
                                                 [entity]="entity"
                                                 [hasAssociateExistingPermission]="hasEditPermission || isConsultantUser"
                                                 [isConsultantUser]="isConsultantUser"
                                                 [roles]="roles"
                                                 style="margin-bottom: 10px;">
                    </contacts-panel-body-actions>
                }
                @if (!isLoading && contacts.length > 0) {
                    <entity-contact-list (contactsUpdated)="load()"
                                         [contacts]="contacts"
                                         [editMode]="isEdit"
                                         [entity]="entity"
                                         [hasEditPermission]="hasEditPermission || isConsultantUser"
                                         [hasViewPermission]="hasViewOrEditPermission"
                                         [roles]="roles"
                                         class="ws-stretch">
                    </entity-contact-list>
                }
                @if (!isLoading && contacts.length === 0) {
                    <div>
                        <h4>No contacts.</h4>
                    </div>
                }
            </div>
        }
    </div>
}
